import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { baseURL } from "../../api";

const baseQueryWithAuth = fetchBaseQuery({
  baseUrl: baseURL,
  prepareHeaders: (headers, { getState }) => {
    // Get the token from your Redux store or wherever it's stored
    let token;

    if (getState()?.auth?.token) {
      token = getState().auth.token; // Assuming your token is in state.auth.token
    }

    // If a token exists, set the Authorization header
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

export {
  baseQueryWithAuth
};